/**
 * 将数组转换成字符串
 *
 * @param {Array} arrList 要转换的数据
 * @returns {String} 转换后的字符串格式
 *
 * tostringFun([1, 2, 3])
 * => 1, 2, 3
 *
 */
function tostringFun(arrList) {
  return arrList.toString();
}
export default tostringFun;
